import {t} from "@lingui/core/macro";
import gql from "graphql-tag";

import type {ApolloGqlClient} from "@khan/data-gql-apollo";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";
import * as locationUtils from "@khan/urls";

type UpdateRewardsData = {
    checkForNewRewards: {
        newBadges: ReadonlyArray<{
            name: string;
        }>;
        newAvatars: ReadonlyArray<{
            name: string;
        }>;
    };
};

export const UPDATE_BADGES_MUTATION: GqlOperation<UpdateRewardsData> = gqlOp(
    gql`
        mutation updateRewards {
            checkForNewRewards {
                newBadges {
                    name
                }
                newAvatars {
                    name
                }
            }
        }
    `,
);

let updatingBadges = false;

export function updateRewards(
    gqlClient: ApolloGqlClient,
    onComplete: () => void,
    reload: () => void = locationUtils.reload,
) {
    if (updatingBadges) {
        return;
    }

    const somethingChanged = () => {
        updatingBadges = false;
        onComplete();
    };

    const nothingChanged = () => {
        // eslint-disable-next-line no-alert
        alert(t`You have not received any new badges or avatars.`);
        updatingBadges = false;
        onComplete();
    };

    updatingBadges = true;

    gqlClient
        .mutate(UPDATE_BADGES_MUTATION)
        .then(({data}) => {
            if (!data || !data.checkForNewRewards) {
                return nothingChanged();
            }

            const badges = data.checkForNewRewards.newBadges;
            const avatars = data.checkForNewRewards.newAvatars;

            const hasNewBadges = badges && badges.length > 0;
            const hasNewAvatars = avatars && avatars.length > 0;

            if (!hasNewBadges && !hasNewAvatars) {
                return nothingChanged();
            }

            reload();
            somethingChanged();
        })
        .catch(nothingChanged);
}
